// authHelper.ts
const USER_PERMISSIONS_KEY = 'userPermissions';

/**
 * Retrieves user permissions from local storage.
 * @returns {string[]} Array of permissions or an empty array if not found.
 */
const getUserPermissions = (): string[] => {
  if (!localStorage) {
    return [];
  }

  const permissionsValue: string | null = localStorage.getItem(USER_PERMISSIONS_KEY);
  if (!permissionsValue) {
    return [];
  }

  try {
    return JSON.parse(permissionsValue) as string[];
  } catch (error) {
    console.error('USER PERMISSIONS LOCAL STORAGE PARSE ERROR', error);
    return [];
  }
};

export { getUserPermissions };
